export const getSelectedRows = (rows = [], rowSelection = {}) =>
  Object.entries(rowSelection)
    .filter(([, selected]) => Boolean(selected))
    .map(([rowIndex]) => rows[Number(rowIndex)])
    .filter(Boolean);
